import React from "react";
import * as S from "../shared/styles";

const Panel: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={S.configCard}>
    <div style={{ fontSize: "1.75rem", fontWeight: 700, color: "#374151", marginBottom: "12px" }}>
      {title}
    </div>
    {children}
  </div>
);

export default Panel;
